import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('cms_user');
    if (saved) {
      try {
        setCurrentUser(JSON.parse(saved));
      } catch {
        localStorage.removeItem('cms_user');
        localStorage.removeItem('cms_token');
      }
    }
    setLoading(false);
  }, []);

  async function signup(email, password, displayName) {
    const res = await axios.post(`${API_URL}/api/users/signup.json`, {
      name: displayName, email, password,
    });
    const { token, user } = res.data;
    const userObj = {
      id: user.id,
      email: user.email,
      displayName: user.name,
      role: user.role || 'user',
      prCredits: user.prCredits || 0,
      guestCredits: user.guestCredits || 0,
    };
    localStorage.setItem('cms_token', token);
    localStorage.setItem('cms_user', JSON.stringify(userObj));
    setCurrentUser(userObj);
  }

  async function login(email, password) {
    const res = await axios.post(`${API_URL}/api/users/login.json`, { email, password });
    const { token, user } = res.data;
    const userObj = {
      id: user.id,
      email: user.email,
      displayName: user.name,
      role: user.role || 'user',
      prCredits: user.prCredits || 0,
      guestCredits: user.guestCredits || 0,
    };
    localStorage.setItem('cms_token', token);
    localStorage.setItem('cms_user', JSON.stringify(userObj));
    setCurrentUser(userObj);
  }

  function logout() {
    localStorage.removeItem('cms_token');
    localStorage.removeItem('cms_user');
    setCurrentUser(null);
  }

  function getIdToken() {
    return localStorage.getItem('cms_token');
  }

  function updateCurrentUser(updates) {
    const updated = { ...currentUser, ...updates };
    localStorage.setItem('cms_user', JSON.stringify(updated));
    setCurrentUser(updated);
  }

  const value = { currentUser, signup, login, logout, getIdToken, updateCurrentUser };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
